import * as React from "react"
import { Icons } from "@/components/icons"

interface RenderIconProps {
  connectionStatus: string
}

// Status colors without blinking
const statusColors: { [key: string]: string } = {
  Active: "#00C853",  
  Delinquent: "#FFA000", 
  Disconnected: "#F44336", 
  "Before Due": "#9C27B0", 
  "Due Today": "#E91E63", 
  "Over Due": "#AD1457", 
  "Disconnection": "#673AB7", 
}

export function MapIcon({ connectionStatus }: RenderIconProps) {
  const color = statusColors[connectionStatus] || "#2196F3" // pending status default color
  return (
    <div>
      <Icons.user fill={color} />
    </div>
  )
}